import React from "react";
import { UserAdd } from "../../assets/images";
import { useNavigate, useParams } from "react-router-dom";
import { CommunityProps } from "../../types";
import { useMutation, useQuery } from "@apollo/client";
import { DELETE_COMMUNITY, GET_COMMUNITIES } from "../../apollo/operations";
import { Loading } from "..";
import { useSelector } from "react-redux";
import { ipfsGatewayImage } from "../../utils/ipfsGatewayImage";

const Members: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const [filterText, setFilterText] = React.useState("");
  const [communityMember, setCommunityMember] = React.useState<CommunityProps>(
    {} as any
  );

  const { loading, error, refetch } = useQuery(GET_COMMUNITIES, {
    onCompleted: (data) => {
      // console.log(data);
      const community = data?.communities.find((c: CommunityProps) => {
        return c.id === id;
      });
      if (community) {
        // console.log(community);
        setCommunityMember(community);
      }
    },
    onError: (err) => {
      console.log(err);
    },
  });

  const [deleteCommunity] = useMutation(DELETE_COMMUNITY, {
    onCompleted(data) {
      refetch();
    },
    onError: (err) => {
      console.log(err);
      const errorMsg = err.graphQLErrors[0]?.extensions?.originalError;
      console.log(errorMsg);
    },
  });

  const navigate = useNavigate();
  const communityMembers = useSelector(
    (state: any) => state.communities.CommunityMembers || []
  );
  const user = useSelector((state: any) => state.user.userDetails);
  const filteredMember = communityMembers && communityMembers?.members?.filter((member: any) =>
    member?.username.toLowerCase().includes(filterText.toLowerCase())
  );


  const handleDelete = () => {
    if (user.id === communityMember?.creator.id) {
      deleteCommunity({
        variables: {
          where: {
            id: communityMember?.id,
          },
        },
      }).then(() => {
        if (refetch) {
          refetch();
        }
        navigate("/ecobook/my-communities");
      });
    }
  };

  if (loading) return <Loading loading={loading} />;
  if (error) return <div className="">error</div>;

  return (
    <div className="w-full bg-white rounded-sm shadow-sm overscroll-auto py-8 flex flex-col items-center justify-between gap-5">
      <input
        type="text"
        placeholder="Search Members"
        className="w-[87%] h-7 text-TransGrey bg-comPagBg pl-6 rounded-sm font-SegoeUI text-sm outline-none"
        onChange={(e) => {
          setFilterText(e.target.value);
        }}
      />
      {filteredMember?.map((mem: any) => {
        let _pImage: string | null = "";

        if (mem.ecobookProfile && mem.ecobookProfile.profileImage !== null) {
          const profileImage = mem.ecobookProfile?.profileImage;

          if (profileImage !== null && profileImage !== undefined) {
            _pImage = profileImage;
          }
        }
        return (
          <div
            className="flex justify-between w-[87%] h-[45px] mt-3"
            key={mem.id}
          >
            <div className="flex w-[75%]">
              {_pImage && (
                <img
                  src={ipfsGatewayImage(_pImage)}
                  alt=""
                  className="w-8 h-7 rounded-full"
                />
              )}
              <h1 className="font-Poppins text-sm font-semibold text-center  mt-2 ml-8 text-LightBlack">
                {`${mem.firstName} ${mem.lastName}`}
              </h1>
            </div>
            <div className="bg-comBlue w-7 h-8 rounded shadow relative mt-2 cursor-pointer px-1 py-1">
              <img src={UserAdd} alt="" className="absolute w-5" />
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default Members;
